<template>
  <div>
    <!-- <FilterItems :datasIn="highways" @filtered="updatedDatas"></FilterItems> -->
    <catalog-table
      :tableHeaders="highwayHeaders"
      :tableData="highways"
      :actions="highwayActions"
      :pageSize="100"
      hidePageSize
      hideFooter
    >
      <template v-if="$can('add', 'Highway', 'highway')" slot="search-toolbar-actions">
        <md-button class="md-success" @click="addHighway">
          <span class="md-label">
            <md-icon class="material-icons">add</md-icon>
          </span>
          Agregar
        </md-button>
      </template>
    </catalog-table>
    <edit-modal
      v-if="editModal"
      @close="editModalHide"
      :highway="this.currentHighway"
      :title="editModalTitle"
      @saved="updateHighway"
      @error="hideEdit"
    ></edit-modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { CatalogTable } from "@/components/";
import EditModal from "./Edit";
import FilterItems from "./Filter";

const highwayHeaders = {
  highwayNumber: "Nombre clave",
  name: "Nombre",
  highwayCompanyName: "Concesionaria",
  customerName: "Cliente",
};

export default {
  name: "Highways",
  components: {
    CatalogTable,
    EditModal,
    FilterItems,
  },

  data() {
    return {
      highways: [],
      newDatas: [],
      datasF: [],
      editModal: false,
      currentHighway: {},
      editModalTitle: "Editar cliente",
      highwayHeaders,
      // highwaySearchableProps: Object.keys(highwayHeaders),
      highwayActions: [
        {
          icon: "edit",
          exe: this.editHighway,
          showIf: () => this.$can("change", "Highway", "highway"),
        },
        {
          icon: "close",
          exe: this.deleteHighway,
          showIf: () => this.$can("delete", "Highway", "highway"),
        },
      ],
    };
  },
  methods: {
    updatedDatas(datas) {
      this.newDatas = datas;
    },

    editModalHide() {
      this.editModal = false;
    },
    editHighway(c) {
      this.editModalTitle = "Editar autopista";
      this.currentHighway = c;
      this.editModal = true;
    },
    deleteHighway(c) {
      this.$confirmMessage(
        { title: `¿Está seguro que desea borrar ${c.name}?` },
        () => {
          return catalogService
            .delete("highway", c, { source: this.highways })
            .then(() => this.$successMessage({ title: "Borrado" }))
            .catch(this.$fireErrorResponse);
        }
      );
    },
    updateHighway({ original, updated }) {
      this.hideEdit();
      if (!original.id) {
        catalogService
          .create("highway", updated, { source: this.highways })
          .then((highway) =>
            this.$successMessage({
              title: `Creado nuevo autopista: ${highway.name}`,
            })
          )
          .catch(this.$fireErrorResponse);
      } else {
        catalogService
          .update("highway", updated, original, { source: this.highways })
          .then(
            (highway) =>
              this.$successMessage({
                title: `${highway.name} fue actualizado.`,
              }),
            this.$fireErrorResponse
          );
      }
    },
    addHighway() {
      this.editModalTitle = "Agregar autopista";
      this.currentHighway = {};
      this.editModal = true;
    },
    hideEdit() {
      this.editModal = false;
    },
  },
  mounted() {
    Promise.all([
      catalogService.fetch("highway"),
      catalogService.fetch("highwaycompany", { useStore: true }),
      catalogService.fetch("customer", { useStore: true }),
    ]).then(([highways, ...res]) => {
      this.highways = highways;
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Highway/Index.vue